import React from 'react';
import {LoadingWrapper} from "../Components/LoadingWrapper";
import EditableReactTableV2 from "../Components/ReactTable/EditableReactTableV2";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {useServiceBase} from "../Components/ReactTable/useServiceBase";
import {EditFormDropdownInputField, EditFormLabelErrorWrapper} from "../Components/ReactTable/EditRecordForm";
import {INDEX_FIELD} from "../Components/ReactTable/common_custom_columns";


export const STANDARDIZED_UNIT_OF_MEASURE_DROPDOWN_OPTIONS = [
    {value: "COUNT", label: "COUNT"},
    {value: "EACH", label: "EACH"},
    {value: "OUNCE", label: "OUNCE"},
    {value: "PINTS", label: "PINTS"},
    {value: "POUND", label: "POUND"},
    {value: "QUARTS", label: "QUARTS"}
]


// WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING
// Note the corresponding logic in edp-pipelines should be kept in sync with this
const numericRegex = "[+-]?[\\d.,]+";
const dividedNumbersRegex = numericRegex + "/" + numericRegex;
const parseNumericValueRegex = "(" + dividedNumbersRegex + "|" + numericRegex + ")";
const regex = new RegExp(parseNumericValueRegex);

export function getEffectiveParsedUnitOfMeasure(displayedUnit) {
    if (!displayedUnit?.replaceAll(/\s/g, "")) {
        return '';
    }
    const nonNumericParts = displayedUnit.replaceAll(/\s/g, "").toUpperCase().split(regex).filter(part => part?.length > 0 && !part.match(regex));
    return nonNumericParts.join('');
}
// WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING WARNING


function StandardizeField({id, form}) {
    const displayedUnit = form.watch("displayedUnit")
    form.setValue(id, getEffectiveParsedUnitOfMeasure(displayedUnit))

    return (
        <EditFormLabelErrorWrapper id={id} form={form} label={'Effective Parsed Unit of Measure'}>
            <input
                type={"text"}
                id={id}
                disabled={true}
                readOnly={true}
                step={"any"}
                {...(form.register(id))}/>
        </EditFormLabelErrorWrapper>
    );
}

function DisplayedUnitField({id, form}) {
    const isRequired = true;
    return (
        <EditFormLabelErrorWrapper id={id} form={form} label={'Retailer Value for Unit of Measure'} isRequired={isRequired}>
            <input
                type={"text"}
                id={id}
                disabled={false}
                readOnly={false}
                step={"any"}
                {...(form.register(id, {required: isRequired}))}/>
        </EditFormLabelErrorWrapper>
    );
}

const StandardizedUnitOfMeasureService = () => {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/standardizedUnitOfMeasure`;
    const {loading, data, onRowEditConfirmed, onRowDeleteConfirmed} = useServiceBase({endpointUrl});

    function validatePreSave({form}) {
        const displayedUnits = getEffectiveParsedUnitOfMeasure(form.getValues('displayedUnit'));
        const index = form.getValues('index');
        const currentDisplayedUnits = data.data
            .filter(item => item.index !== index)
            .map(item => getEffectiveParsedUnitOfMeasure(item.displayedUnit));

        const errors = []
        if (currentDisplayedUnits.includes(displayedUnits)) {
            errors.push("A mapping with the same Effective Parsed Unit of Measure already exists.")
        }
        if (errors.length > 0) {
            form.setError('displayedUnit', {type: 'custom', message: errors});
        }

        return errors.length === 0;
    }

    async function getOnRowEditConfirmedWrapper(newOrUpdatedRow) {
        delete newOrUpdatedRow.effectiveMatchValue;
        await onRowEditConfirmed(newOrUpdatedRow);
    }

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Produce"}, {label: "Standardized Unit of Measure"}]}/>} name={"Standardized Unit Of Measures"}>
            <LoadingWrapper loading={loading}>
                <EditableReactTableV2
                    filterable
                    data={data.data}
                    columns={[
                        {header: "Standard Unit of Measure", id: "standardizedUnit", accessorKey: "standardizedUnit"},
                        {header: "Retailer Value for Unit of Measure", id: "displayedUnit", accessorKey: "displayedUnit"},
                        {header: "Effective Parsed Unit of Measure", id: "effectiveMatchValue", accessorFn: (row) => getEffectiveParsedUnitOfMeasure(row.displayedUnit)}
                    ]}
                    editTable={[
                        INDEX_FIELD,
                        {id: 'standardizedUnit', Component: args => <EditFormDropdownInputField {...args} options={STANDARDIZED_UNIT_OF_MEASURE_DROPDOWN_OPTIONS} isRequired/>},
                        {id: 'displayedUnit', Component: args => <DisplayedUnitField {...args} />},
                        {id: 'effectiveMatchValue', Component: args => <StandardizeField {...args} />}
                    ]}
                    initialState={{pagination: {pageSize: 25}}}
                    validatePreSave={validatePreSave}
                    onRowEditConfirmed={getOnRowEditConfirmedWrapper}
                    onRowDeleteConfirmed={onRowDeleteConfirmed}
                />
            </LoadingWrapper>
        </Page>
    );
};

export default StandardizedUnitOfMeasureService;